import styled, { Spacing, Color } from '@nfinite/react-hubstairs/styled'

import ButtonComponent from 'components/Commons/Button'
import IconComponent from 'components/Commons/Icon'
import Select from 'components/Commons/Inputs/Select'

const SIZE_BUTTON = 40

export const Icon = styled(IconComponent)`
  width: 16px;
  height: 16px;
`

export const Item = styled('div')`
  ${({ onClick }) => onClick && `cursor: pointer;`}
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${({ selected, theme }) => selected && `font-weight: ${theme.getFontWeight('bold')};`}
`

export const Button = styled(ButtonComponent)`
  min-width: unset;
  min-height: unset;
  padding: 0;
  width: ${SIZE_BUTTON}px;
  height: ${SIZE_BUTTON}px;
`

export const ArrowIcon = styled(IconComponent)`
  width: 10px;
  height: 10px;
  ${Spacing.generateMargin({ left: 'xs' })}
  transform: rotate(90deg);

  & svg {
    fill: ${Color.get('text')};
  }
`

export const RegularSelect = styled(Select)`
  width: fit-content;
  & .nfinite-select__control {
    min-height: 40px !important;
    max-height: 40px !important;
  }
  & .nfinite-select__menu {
    width: max-content;
    right: 0;
    left: auto;
  }
`
